module.exports = __webpack_public_path__ + "static/odd-477afb1983f5c5821a9cd8a1bec6b789.jpg";